import { TipoAnexoEnvio } from "./tipo-anexo-envio";

export class TipoAnexoForm extends TipoAnexoEnvio {
    idTipoAnexo: number;

    constructor(obj?: any) {
        super(obj);
        this.idTipoAnexo = obj?.IdTipoAnexo ?? obj?.idTipoAnexo ?? 0;
        if (obj?.IdTipoAnexo) {
            this.dsTipoAnexo = obj.DsTipoAnexo;
            this.flObrigatorio = obj.FlObrigatorio;
            this.flPermiteMultiplos = obj.FlPermiteMultiplos;
            this.nrOrdem = obj.NrOrdem ?? null;
            this.dsTipoEdital = obj.DsTipoEdital ?? null;
            this.tpGrupoAnexo = obj.TpGrupoAnexo;
            this.dtInicioVigencia = obj.DtInicioVigencia ?? null;
            this.dtFimVigencia = obj.DtFimVigencia ?? null;
        }
    }

    toEnvio(): TipoAnexoEnvio {
        return new TipoAnexoEnvio(this);
    }
}